class SmoothSlider {
  /**
   * Initialize the SmoothSlider class with the provided element and its corresponding DOM element.
   * Set the configuration for the slider and the mobile view.
   * If the window width is less than 1024px, handle the mobile view.
   *
   * @param element {string} - The selector for the slider element.
   * @param config
   * @param force
   */
  constructor(element, config = null, isAutoplay = true, force = false) {
    this.element = element;
    this.config = config;
    this.isAutoplay = isAutoplay;
    this.elements = document.querySelectorAll(this.element);
    if (this.elements.length <= 0) return;

    this.init(force);
  }

  init(force) {
    if (window.innerWidth < 1024) {
      if (force) {
        this.mobileHandle();
      } else {
        window.addEventListener("DOMContentLoaded", () => {
          this.mobileHandle();
        });
      }
    } else {
      this.pcHandle();
    }
  }

  /**
   * Initialize the slider for each element with the provided element selector.
   */
  pcHandle() {
    this.elements.forEach((element) => {
      const config = {
        direction: "horizontal",
        slidesPerView: "auto",
        centeredSlides: false,
        spaceBetween: 0,
        loop: true,
        watchSlidesProgress: true,
        speed: 1100,
        autoplay: {
          delay: 4000,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1024: {
            spaceBetween: 0,
            autoplay: {
              enabled: false,
            },
          },
        },
        ...this.config,
      };

      console.log("Found the target node");
      this.slider = new Swiper(element, config);
      console.log("Finished initialization");
    });
  }

  /**
   * Initialize the mobile view slider for each element with the provided mobile selector.
   */
  mobileHandle() {
    this.elements.forEach((element) => {
      this.slider = new Swiper(element, {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1024: {
            spaceBetween: 0,
            autoplay: {
              enabled: false,
            },
          },
        },
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: {
          enabled: this.isAutoplay,
          delay: 4000,
        },
        speed: 1000,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        ...this.config,
      });
    });
  }
}
